import axios from 'axios'
import verify from './../views/verifyDatas';
import url from './Url';

class NewFraga extends url {
    constructor() {
        super()
    }

    selectBrands = () => {
        return axios.get(`${this.url()}/vehicleBrands`)
            .then(vehicleBrands => { return vehicleBrands })
            .catch(err => { return err })
    };

    selectNames = (name) => {

        return axios.get(`${this.url()}/vehicleName/${name}`)
            .then(vehicleNames => {
                return vehicleNames
            })
            .catch(err => { return err })
    };

    selectModel = (model) => {

        return axios.get(`${this.url()}/vehicleModels/${model}`)
            .then(vehicleModels => {
                return vehicleModels
            })
            .catch(err => { return err })
    };

    selectAllYears = (vehicleNames, vehicleModels) => {
        return axios.get(`${this.url()}/vehicleYears?vehicleNames=${vehicleNames}&vehicleModels=${vehicleModels}`)
            .then(vehicleAllYears => {
                return vehicleAllYears
            })
            .catch(err => { return err })
    };

    selectEnginer = (year) => {
        return axios.get(`${this.url()}/vehicleEngine/${year}`)
            .then(vehicleEngine => {
                return vehicleEngine
            })
            .catch(err => { return err })
    };

    selectEnginerConfig = (engineNames) => {
        return axios.get(`${this.url()}/vehicleEngineConf/${engineNames}`)
            .then(vehicleEngineConfig => {
                return vehicleEngineConfig
            })
            .catch(err => { return err })
    };

    selectAplication = (nomePeca, montadora, nome, modelo, ano_venda, motor, confi_motor) => {
        //console.log(nomePeca)

        return axios.get(`${this.url()}/vehicles?nomePeca=${nomePeca}&montadora=${montadora}&nome=${nome}&modelo=${modelo}&ano_venda=${ano_venda}`)
            .then(vehicles => {
                //console.log(vehicles)
                return vehicles
            })

            .catch(err => { return err })
    };

    prodName = (nomePeca, selectedBrands, selectedNames, selectedModels, selectedAllYears, selectedEnginer, selectedEnginerConfig, fabricante, idCompany, page) => {
        return axios.get(`${this.url()}/produ-aplication?nomePeca=${nomePeca}&montadora=${selectedBrands}&nome=${selectedNames}&modelo=${selectedModels}&ano_venda=${selectedAllYears}&motor=${selectedEnginer}&confi_motor=${selectedEnginerConfig}&fabricante=${fabricante}&idCompany=${idCompany}&page=${page}`)
            .then(nome => {
                return nome?.data
            })
            .catch(err => { return err })
    };

    prodNameTESTE = (nomePeca, idCompany) => {

        return axios.get(`${this.url()}/produ-less/${nomePeca}?idCompany=${idCompany}`)
            .then(nome => {
                return nome?.data
            })
            .catch(err => { return err })
    };

}

export default NewFraga;